



// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {
        id:1,
        coverImg: "feedback-app.jpg" ,
        title: "Feedback App",
        description: " A react feedback app which can add, edit or delete feedback",
        url:"https://anubhavnegi-portfolio-feedback-app.netlify.app/"
    },

    {
        id:2,
        coverImg: "memegenerator.JPG" ,
        title: "Meme Generator",
        description: "Generate random memes and spread fun 😈",
        url:"https://starlove54.github.io/meme-template-generator/"

    },

    {
        id:3,
        coverImg: "speechsynthesis.jpg" ,
        title: "Speech Synthesis",
        description: "Generate speech of input text in different voices",
        url:"https://speechsynthesis-app-anubhav-portfolio.netlify.app/"

    },

    {
        id:4,
        coverImg: "nativespeechrecognition.jpg" ,
        title: "Native Speech Recognition",
        description: "A speech to text project",
        url:"https://speechrecognition-anubhav-portfolio.netlify.app/"

    },

    
    {
        id:5,
        coverImg: "anubhav-logo.png" ,
        title: "Anubhav Negi",
        description: "My personal creative space",
        url:"https://anubhavnegi.com/"

    },

    {
        id:6,
        coverImg: "dad-jokes.jpg" ,
        title: "Dad Jokes",
        description: "A nuxt application that displays corny dad jokes.",
        url:"https://dadjokes-anubhav-portfolio.netlify.app/"

    },
    {
        id:7,
        coverImg: "noise-flow-field.jpg" ,
        title: "Noise Flow Field",
        description: "A noise flow field generated by particles.",
        url:"https://openprocessing.org/sketch/1270616"

    },
    {
        id:8,
        coverImg: "netflix-clone-landing-page.jpg" ,
        title: "Netflix Clone",
        description: "A netlfix clone made purely with HTML, CSS and javascript",
        url:"https://netflix-landingpage-anubhav-portfolio.netlify.app/"

    }
]
